import React from 'react';
import ListActions from './ListActions'
import {
	List,
	Responsive,
	SimpleList,
	Datagrid,
	TextField,
	NumberField,
	SelectInput,
	DisabledInput,
	NumberInput,
	SimpleForm,
	ReferenceInput,
	Edit,
	SelectField,
} from 'admin-on-rest'
import { DealershipYearFilters } from './Filters'
import EditButton from './EditButton'

export const SalesSupportTeamIncentive = (props) => (
    <List {...props}
		title="Sales Support Team Incentive"
		filters={<DealershipYearFilters />}
		actions={<ListActions refreshInterval="900000" />}
		sort={{ field: 'month', order: 'ASC' }}
		>
		<Responsive
            // small={
            //     <SimpleList
            //         primaryText={record => record.cs_num}
            //     />
            // }
            large={
				<Datagrid>
					<SelectField label="Month" source="month" allowEmpty translateChoice={false} optionText="name" optionValue="id" choices={[
						{ id: "1", name: "January" },
						{ id: "2", name: "February" },
						{ id: "3", name: "March" },
						{ id: "4", name: "April" },
						{ id: "5", name: "May" },
						{ id: "6", name: "June" },
						{ id: "7", name: "July" },
						{ id: "8", name: "August" },
						{ id: "9", name: "September" },
						{ id: "10", name: "October" },
						{ id: "11", name: "November" },
						{ id: "12", name: "December" },
					]} options={{ disabled: true }} />
					<EditButton label="" />
					<TextField source="num_members_ssu" label="# Members in SSU" />
					<TextField source="total_releases" label="Accts Released" />
					<TextField source="num_incentive" label="Accts w/ Incentive" />
					<TextField source="total_collected_proceeded" label="Proc Collected" />
					<NumberField source="doc_def_rate" label="Doc Def" options={{ maximumFractionDigits: 2, style: 'percent' }}/>
					<NumberField source="incentive_per_account" label="Incentive/Account" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP' }}/>
					<NumberField source="total_incentive" label="Total Incentive" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP'  }}/>
					<NumberField source="withholding_tax" label="Witholding Tax" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP'  }}/>
					<NumberField source="net_incentive" label="Net Incentive" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP'  }}/>
					<NumberField source="sales_support_member_incentive" label="Member Incentive" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP'  }}/>
					<NumberField source="sales_support_head_incentive" label="Head Incentive" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP'  }}/>
		        </Datagrid>
            }
        />
    </List>
)

export const SalesSupportTeamIncentiveEdit = (props) => (
    <Edit title='Testing' {...props}>
        <SimpleForm>
			<ReferenceInput label="Dealership" source="dealership" reference="dealerships">
				<SelectInput options={{ disabled: true }}/>
			</ReferenceInput>
			<SelectInput label="Month" source="month" allowEmpty translateChoice={false} optionText="name" optionValue="id" choices={[
				{ id: "1", name: "January" },
				{ id: "2", name: "February" },
				{ id: "3", name: "March" },
				{ id: "4", name: "April" },
				{ id: "5", name: "May" },
				{ id: "6", name: "June" },
				{ id: "7", name: "July" },
				{ id: "8", name: "August" },
				{ id: "9", name: "September" },
				{ id: "10", name: "October" },
				{ id: "11", name: "November" },
				{ id: "12", name: "December" },
			]} options={{ disabled: true }} />
            <DisabledInput label="Year" source="year" />
			<NumberInput source="num_members_ssu" label="Number of Members in SSU" autoFocus />
        </SimpleForm>
    </Edit>
);



// WEBPACK FOOTER //
// ./src/reports/SalesSupportTeamIncentive.js